<template functional>
  <div class="tumbler">
    <div class="tumbler__label">
      {{ props.currencyLabel }}
    </div>
    <div
      v-for="cur in props.currencyList"
      :key="cur.id"
      class="tumbler__item "
      :class="{ 'active button--corner': cur.id === props.currency.id }"
      @click="listeners.changeCurrency({ currency: cur })"
    >
      <span v-html="cur.symbol"></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "CurrencyPicker",
  props: {
    currencyLabel: {
      type: String,
      required: true,
    },
    currency: {
      type: Object,
      required: true,
    },
    currencyList: {
      type: Array,
      required: true,
    },
  },
};
</script>
